import {DateTime} from 'luxon'

export interface TaxRefundState {
  id: string,
  status: number | 0,
  errorCode: string | null
  errorMessage: string | null
  taxrefund: TaxRefund | null,
  confirmationStep: number | 0,
  createdAt: DateTime,
  surveyKey: string,
  commissionProposal: number,
}

export interface PerYear {
  year: string | null,
  amount: number | 0,
}

export interface PerYearStatement {
  perYear: PerYear[],
  expected: number | 0,
}

export const enum RefundStatus {
  에러 = -1,
  환급급조회전 = 0,
  환급급조회중 = 1,
  환급급확인전 = 2,
  환급급확인 = 3,
  환급급신청 = 4,
  기장상담신청 = 5,
  설문작성대기 = 6,
  확정진단중 = 7,
  접수준비중 = 8,
  국세청환급대기 = 9,
  환급완료 = 10,
}

export interface TaxRefund {
  bizNo: string | null,
  refund: number | 0,
  refundDeclareYear: string | null,
  refundStartYear: string | null,
  refundEndYear: string | null,
  salesPerYear: PerYear[],
  salesExpected: number | 0,
  taxPerYear: PerYear[],
  taxExpected: number | 0,
  refundPerYear: PerYear[],
  refundExpected: number | 0,
}

export interface TaxRefundResultResponse {
  bizNo: string | null,
  refund: number | 0,
  refundDeclareYear: string | null,
  refundStartYear: string | null,
  refundEndYear: string | null,
  salesPerYear: {},
  taxPerYear: {},
  refundPerYear: {},
}

export interface TaxRefundResponse {
  id: string,
  status: number | 0,
  errorCode: string | null
  errorMessage: string | null
  result: TaxRefundResultResponse,
  createdAt: DateTime,
  commissionProposal: number | null
}

export interface SurveyKeyResponse {
  bizNo: string,
  estDay: string,
  sessionKey: string,
}

export interface UpdateBankAccountPayload {
  bankName: string;
  bankOwnerName: string;
  bankAccountName: string;
  taxRefundId: string;
  bizId: string;
}

export interface GetPresignedUrlForSignaturePayload {
  taxRefundId: string;
  bizId: string;
}

interface PresignedUrl {
  url: string;
  fields: {
    key: string;
    policy: string;
    xAmzAlgorithm: string;
    xAmzCredential: string;
    xAmzDate: string;
    xAmzSignature: string
  }
}
export interface GetPresignedUrlForSignatureResponse {
  key: string;
  presignedUrl: PresignedUrl;
}

export interface UploadSignatureImagePayload {
  presignedUrl: PresignedUrl;
  file: File;
}

export interface UpdateSignaturePayload {
  taxRefundId: string;
  presignedUrlKey: string;
  bizId: string;
}

export interface GetContractPayload {
  taxRefundId: string;
  bizId: string;
}

export interface GetContractResponse {
  bankName: string;
  bankAccountNumber: string;
  contractAt: string;
  expectedRefund: string;
  commissionRate: number;
}
